import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Tooltip from "components/Tooltip";

const DGNBItem = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      content={
        disabled ? t("buildingMaterialResources.exportNoLicenseTooltip") : ""
      }
      className={disabled ? "!cursor-not-allowed" : "cursor-pointer"}
    >
      <div
        key={0}
        className="w-full flex flex-row items-center justify-between"
      >
        <div className={clsx("text-gray-900", "font-[400]")}>
          {t("DGNB.export_dgnb")}
        </div>
      </div>
    </Tooltip>
  );
};

export default DGNBItem;
